module.exports = "<p>\r\n  warehouse works!\r\n</p>\r\n"